import { Component, inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppointmentService } from '../appointment.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AppStateService } from '../../app-state.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { ConfigService } from '../../config.service';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-deeplink-handler',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatProgressBarModule,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './deeplink-handler.component.html',
  styleUrls: ['./deeplink-handler.component.scss']
})
export class DeeplinkHandlerComponent implements OnInit {
  loading = false;
  loadingStatus = '';
  orgId = '';
  clientId = '';
  patientId = '';
  appointmentService = inject(AppointmentService);
  snackBar = inject(MatSnackBar);
  router = inject(Router);
  appStateService = inject(AppStateService);
  appConfig: any;
  configService = inject(ConfigService);
  deepLinkData: any;
  actionMessage = '';
  tokenInfo: any;
  actionCompleted = false;

  constructor() {
    const state = this.appStateService.getState();
    this.appConfig = this.configService.getConfigData();
    this.orgId = state.orgId || '';
    this.clientId = state.clientId || '';
    this.patientId = state.patientId || '';
    this.deepLinkData = state.deeplinkData || {};
    this.tokenInfo = state.deeplinkData.tokenInfo || {};
  }

  ngOnInit(): void {
    if (!this.deepLinkData || !this.deepLinkData.actionType) {
      this.showErrorMessage('Invalid action detected. Please check your deep link.');
      return;
    }

    switch (this.deepLinkData.actionType) {
      case 'appointment_confirm':
        this.handleAppointmentAction('Confirming your appointment...', 'confirm');
        break;
      case 'appointment_cancel':
        this.handleAppointmentAction('Canceling your appointment...', 'cancel');
        break;
      case 'appointment_reschedule':
        this.actionMessage = 'Redirecting to reschedule your appointment...';
        this.rescheduleAppointment(this.tokenInfo.appointment_number);
        break;
      case 'clinic_review':
        this.actionMessage = 'Loading review form...';
        this.router.navigate(['/clinic-review']);
        break;
      default:
        this.showErrorMessage('Invalid action detected. Please check your deep link.');
    }
  }

  handleAppointmentAction(message: string, action: 'confirm' | 'cancel'): void {
    this.actionMessage = message;
    this.loading = true;
    this.loadingStatus = message;

    this.appointmentService.manageAppointment(this.clientId, this.patientId, this.tokenInfo.appointment_number, action).subscribe({
      next: () => {
        this.loading = false;
        this.actionCompleted = true;
        this.actionMessage = `Appointment ${action}ed successfully.`;
        this.snackBar.open(`Appointment ${action}ed successfully.`, 'Close', { duration: 5000 });
      },
      error: (error) => {
        this.loading = false;
        this.actionMessage = `Error ${action}ing appointment.`;
        this.showErrorMessage(`Error ${action}ing appointment.`);
      }
    });
  }

  rescheduleAppointment(appointmentNumber: string): void {
    this.loading = false;
    this.router.navigate(['/appointment', appointmentNumber]);
  }

  showErrorMessage(message: string): void {
    this.loading = false;
    this.actionMessage = message;
    this.snackBar.open(message, 'Close', { duration: 5000 });
  }
}
